import _classCallCheck from "/home/skynet/Zhifan/repos/visualize-rotations/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/skynet/Zhifan/repos/visualize-rotations/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
export var DepthToSpaceProgram = /*#__PURE__*/function () {
  function DepthToSpaceProgram(outputShape, blockSize, dataFormat) {
    _classCallCheck(this, DepthToSpaceProgram);
    this.variableNames = ['x'];
    this.outputShape = [];
    this.outputShape = outputShape;
    this.blockSize = blockSize;
    this.dataFormat = dataFormat;
    this.userCode = "\n    void main() {\n      ivec4 coords = getOutputCoords();\n      int b = coords[0];\n      int h = ".concat(this.getHeightCoordString(), ";\n      int w = ").concat(this.getWidthCoordString(), ";\n      int d = ").concat(this.getDepthCoordString(), ";\n\n      int in_h = h / ").concat(blockSize, ";\n      int offset_h = imod(h, ").concat(blockSize, ");\n      int in_w = w / ").concat(blockSize, ";\n      int offset_w = imod(w, ").concat(blockSize, ");\n      int offset_d = (offset_h * ").concat(blockSize, " + offset_w) *\n        ").concat(this.getOutputDepthSize(), ";\n      int in_d = d + offset_d;\n\n      float result = ").concat(this.getInputSamplingString(), ";\n      setOutput(result);\n    }\n  ");
  }
  _createClass(DepthToSpaceProgram, [{
    key: "getHeightCoordString",
    value: function getHeightCoordString() {
      if (this.dataFormat === 'NHWC') {
        return "coords[1]";
      } else {
        return "coords[2]";
      }
    }
  }, {
    key: "getWidthCoordString",
    value: function getWidthCoordString() {
      if (this.dataFormat === 'NHWC') {
        return "coords[2]";
      } else {
        return "coords[3]";
      }
    }
  }, {
    key: "getDepthCoordString",
    value: function getDepthCoordString() {
      if (this.dataFormat === 'NHWC') {
        return "coords[3]";
      } else {
        return "coords[1]";
      }
    }
  }, {
    key: "getOutputDepthSize",
    value: function getOutputDepthSize() {
      if (this.dataFormat === 'NHWC') {
        return this.outputShape[3];
      } else {
        return this.outputShape[1];
      }
    }
  }, {
    key: "getInputSamplingString",
    value: function getInputSamplingString() {
      if (this.dataFormat === 'NHWC') {
        return "getX(b, in_h, in_w, in_d)";
      } else {
        return "getX(b, in_d, in_h, in_w)";
      }
    }
  }]);
  return DepthToSpaceProgram;
}();